import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useContext } from "react";
import { GiCheckMark } from "react-icons/gi";
import './Payment.css'
import { useUser } from "../../context/UserProvider";
import Navbar from "../../components/navbars/Navbar";
import { CartContext } from "../../context/CartContext";




const PaymentSuccess = () => {
    const navigate = useNavigate();
    const { orderId } = useParams();
    const { mongoUser } = useUser();
    const {clearCart} = useContext(CartContext)

    useEffect(() => {
        clearCart();
    }, [clearCart]);
    
    return (
        <div className="payment-container">
            <Navbar />
            <div className="payment-icon">
                <GiCheckMark size={80} color="green" />
            </div>
            <h1 className="payment-message success">Payment Successful!</h1>
            <p>Your order has been processed successfully.</p>
            <button className="payment-button success-button" onClick={() => navigate("/")}>
                Go to Homepage
            </button>
            <button className="payment-button success-button" onClick={() => navigate(`/${mongoUser._id}/orders`)}>
                Go to My Orders and upload images
            </button>
        </div>
    );
};

export default PaymentSuccess;
